import { Grid, Typography, TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

const TextQuestion = (props) => {
    const { question, questionnaireIndex, questionIndex, editMode, name = null } = props;
    const { formState, setValue } = useFormContext();
    const { errors } = formState;

    useEffect(() => {
        if (name) {
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].answer`, [question.Default] ?? null);
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        } else {
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`, [question.Default] ?? null);
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        }
    }, [questionIndex, questionnaireIndex]);

    const handleTextChange = (event) => {
        if (name) {
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].answer`, [event.target.value]);
            setValue(`${name}[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        } else {
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`, [event.target.value]);
            setValue(`questionnaire[${questionnaireIndex}].answers[${questionIndex}].question`, question?.Id);
        }
    };

    return (
        <Grid item container xs={12}>
            <Grid item xs={12}>
                <Typography gutterBottom>{question?.Title}</Typography>
            </Grid>
            <Grid item xs={12}>
                <TextField
                    sx={{
                        borderColor: 'red'
                    }}
                    onChange={handleTextChange}
                    InputLabelProps={{ shrink: true }}
                    defaultValue={question?.Default ?? null}
                    error={
                        name
                            ? !!errors[`${name}[${questionnaireIndex}].answers[${questionIndex}].answer`]
                            : !!errors[`questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`]
                    }
                    helperText={
                        name
                            ? errors[`${name}[${questionnaireIndex}].answers[${questionIndex}].answer`]?.message
                            : errors[`questionnaire[${questionnaireIndex}].answers[${questionIndex}].answer`]?.message
                    }
                    required={question?.rules?.required}
                    size="small"
                    fullWidth
                    disabled={!editMode}
                />
            </Grid>
        </Grid>
    );
};

export default TextQuestion;
